module.exports = "<div class=\"x_panel\">\n    <div class=\"x_title\">\n        <h3 *ngIf=\"isTitleDefined()\">{{ title }}</h3>\n        <ng-content select=\"panel-header\"></ng-content>\n    </div>\n\n    <div class=\"x_content\">\n        <ng-content></ng-content>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/panel/panel.template.html
// module id = 1034
// module chunks = 0